import { useState, useEffect } from "react";
import TableDialog from "../TableDialog";
import { TextField } from "@material-ui/core";
import { getTranslation } from "../../../../heplers/translationHelper";

export const AddNewAreaDialog = ({ open, onClose, onSubmit }) => {
	const [newAreaName, setNewAreaName] = useState("");
  
	useEffect(() => {
		if (!open) {
			setNewAreaName("");
		}
	}, [open]);

	return (
		<TableDialog
			open={open}
			onClose={() => onClose()}
			title={getTranslation(
										  "Add New Area",
										  "Add New Area",
										  "Add New Area"
										)}
			onConfirm={() => {
				if (!newAreaName.trim()) {
					alert(getTranslation("Area name cannot be empty."));
					return;
				} else {
					onSubmit(newAreaName);
					onClose();
				}
			}}
			confirmText={getTranslation(
				"Add",
				"Add",
				"Add"
			  )}
		>
			<TextField
				label={getTranslation(
					"Area Name",
					"Area Name",
					"Area Name"
				  )}
				value={newAreaName}
				onChange={(e) => setNewAreaName(e.target.value)}
				fullWidth
			/>
		</TableDialog>
	);
};
